module.exports = __webpack_public_path__ + "img/00022.201efe0e.webp";